import { ApiConfig } from "../..";

type ValidateBusinessId = {
    status: boolean
}
export const isBusinessIdExists = (config: ApiConfig, token: string) => async (businessId: string, datatype: string): Promise<ValidateBusinessId> => {   
    return fetch(`${config.API_URL}/content/check/businessId?businessId=${encodeURIComponent(businessId)}&dataType=${encodeURIComponent(datatype)}`, {
        method: 'GET',
        headers: new Headers({
            'Authorization': 'Bearer ' + token
        })
    })
    .then((res) =>res.json())
    .catch(_ => ({status: false}));
} 